export default __webpack_public_path__ + "static/media/1892.2f0cf943.png";